import { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { obtenirToken } from '../../commons/gestioWebToken';
import { existeixUsuariRegistrat } from '../../selectors/selector_login';
import { fetchLoginAmbToken } from '../../commons/consultesServidor';
import { loginOmplirDadesUsuariRegistrat } from '../../actions';

class SeguretatRouter extends Component {
    constructor(props) {
        super(props);
        this.redirigirAPaginaDeLogin = this.redirigirAPaginaDeLogin.bind(this);
        this.gestionarExitConsultaToken = this.gestionarExitConsultaToken.bind(this);
        this.gestionarErrorConsultaToken = this.gestionarErrorConsultaToken.bind(this);
    }

    redirigirAPaginaDeLogin() {
        this.props.router.replace('/login');
    }

    gestionarExitConsultaToken(dadesUsuari) {
        const { loginOmplirDadesUsuariRegistrat} = this.props;
        loginOmplirDadesUsuariRegistrat(dadesUsuari);
    }

    gestionarErrorConsultaToken() {
        this.redirigirAPaginaDeLogin();
    }

    comprovarSiExisteixUsuariRegistrat() {
        const { calFerLogin } = this.props;
        if (calFerLogin) {
            const token = obtenirToken();
            if (token) {
                fetchLoginAmbToken(token)
                    .then(this.gestionarExitConsultaToken, this.gestionarErrorConsultaToken);
            } else {
                this.redirigirAPaginaDeLogin();
            }
        }
    }

    componentDidMount() {
        this.comprovarSiExisteixUsuariRegistrat();
    }

    componentDidUpdate() {
        this.comprovarSiExisteixUsuariRegistrat();
    }

    render() {
        const { calFerLogin } = this.props;
        if (!calFerLogin) {
            return this.props.children;
        } else {
            return null;
        }
    }
}

function mapStateToProps(state) {
    return {
        calFerLogin: !existeixUsuariRegistrat(state)
    };
}

SeguretatRouter.propTypes = {
    calFerLogin: PropTypes.bool,
    children: PropTypes.object,
    router: PropTypes.object,
    loginOmplirDadesUsuariRegistrat: PropTypes.func
};

export default connect(mapStateToProps, { loginOmplirDadesUsuariRegistrat })(SeguretatRouter);



// WEBPACK FOOTER //
// ./src/components/seguretat/seguretatRouter.js